export const filterFirstLast = (e, i, a) => i === 0 || i === a.length - 1;
